import React, { useEffect } from 'react';

function Toast({ message, type = 'success', isVisible, onClose }) {
  useEffect(() => {
    if (isVisible && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  // Use brand colors: blend of navy blue (secondary) and red (primary)
  const bgGradient = type === 'error' 
    ? 'bg-gradient-to-r from-red-600 via-red-700 to-red-800'
    : type === 'info'
    ? 'bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800'
    : 'bg-gradient-to-r from-secondary via-[#5a2f42] to-primary';
  
  const icon = type === 'success' ? (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
  ) : type === 'error' ? (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
    </svg>
  ) : (
    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
    </svg>
  );

  // Truncate long messages to keep toast compact
  const maxLength = 60;
  const displayMessage = message.length > maxLength 
    ? message.substring(0, maxLength) + '...' 
    : message;

  return (
    <div className="fixed top-16 sm:top-20 right-3 sm:right-6 z-[100] animate-bounce-in-right max-w-sm">
      <div className={`${bgGradient} text-white px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg shadow-xl backdrop-blur-sm animate-bounce-pop border border-white/30 ring-2 ring-secondary/20 overflow-hidden relative cursor-pointer`} onClick={onClose}>
        <div className="flex items-center gap-2">
          <span className="animate-bounce-pop flex-shrink-0">{icon}</span>
          <span className="text-xs sm:text-sm font-medium leading-tight">{displayMessage}</span>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              if (onClose) onClose();
            }}
            className="ml-1 flex-shrink-0 text-white/80 hover:text-white transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Timer Progress Bar */}
        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white/30">
          <div className="h-full bg-white animate-toast-timer"></div>
        </div>
      </div>
    </div>
  );
}

export default Toast;
